import PropTypes from "prop-types"
import { map } from "lodash"
import classNames from "classnames"
import ItemCell from "./item-cell"

export default function Column({ id, data, items, column, cellWidth, getBackgroundColor }) {
  const { noData, isUnmodeled, color } = column
  const loading = !data && !noData && !isUnmodeled

  return <div className={classNames("group-column", { loading })}>
    <div className="background-color" style={getBackgroundColor(loading, color)} />
    {map(items, (item, j) => <ItemCell key={`${id}-row${j}`} item={item} width={cellWidth} color={color} loading={loading} />)}
  </div>
}
Column.propTypes = {
  id: PropTypes.string,
  column: PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    noData: PropTypes.bool,
    isUnmodeled: PropTypes.bool,
  }).isRequired,
  items: PropTypes.array.isRequired,
  data: PropTypes.object,
  cellWidth: PropTypes.number.isRequired,
  getBackgroundColor: PropTypes.func.isRequired,
}
